module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "events"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Events")]), _vm._v(" "), _vm._l((_vm.events), function(event) {
    return (_vm.events.length) ? _c('event', {
      attrs: {
        "event": event
      }
    }) : _c('div', [_c('p', [_vm._v("Check back for upcoming events!")])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-559335fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Events.vue
// module id = 319
// module chunks = 1